import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/globals.css";
import "./lib/i18n";
import App from "./App";
import { TenantAuthProvider } from "./context/auth";
import { PlatformAuthProvider } from "./context/platformAuth";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TenantAuthProvider>
        <PlatformAuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PlatformAuthProvider>
      </TenantAuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed", error);
    });
  });
}
